import { Flight } from '../types';
import { flightMotohoursEnd } from './flightDisplay';
import { SortValueKind } from './tableSort';

export type FlightSortKey = keyof Flight | 'fuel_used_liters' | 'fuel_cost';

/**
 * После даты: непрерывные моточасы ↓, затем id ↓.
 * Нельзя сортировать по показанию тахометра — после замены прибор снова «с нуля».
 */
export const FLIGHT_SORT_SECONDARY: { key: FlightSortKey; direction: 'asc' | 'desc' }[] =
  [
    { key: 'motohours_end', direction: 'desc' },
    { key: 'id', direction: 'desc' },
  ];

/** Непрерывная наработка для порядка в журнале (не показание тахометра). */
export const flightMotohours = (row: Flight): number => flightMotohoursEnd(row);

export const flightSortKind = (key: FlightSortKey): SortValueKind => {
  switch (key) {
    case 'date':
      return 'date';
    case 'id':
    case 'hobbs_end':
    case 'tach_end':
    case 'motohours_end':
    case 'hours':
    case 'landings':
    case 'fuel':
    case 'oil':
    case 'fuel_used_liters':
    case 'fuel_cost':
      return 'number';
    default:
      return 'string';
  }
};

export const flightSortValue = (row: Flight, key: FlightSortKey): unknown => {
  // Колонка «Тахометр» и motohours — порядок по непрерывным моточасам
  if (key === 'hobbs_end' || key === 'tach_end' || key === 'motohours_end') {
    return flightMotohours(row);
  }
  return row[key as keyof Flight];
};
